import {getOrphanDeposits} from "./actions/getOrphanDeposits";
import {getOrphanDeposit} from "./actions/getOrphanDeposit";

export const actions = {
    getOrphanDeposits,
    getOrphanDeposit,
};
